import { useEffect, useContext, useState } from "react";
import { StoreContext } from "../contexts/store-context";
import { runQuery } from "./use-query";

const QUERY_ALL = `
  query {
    recipes {
      id
      imageUrl
      ingredients
      instructions
      name
      recipeUrl
    }
  }
`;

export function useResources(modelName) {
  let [initialRender, setInitialRender] = useState(true);
  let { store, dispatch } = useContext(StoreContext);
  let hasFetchedAllRecipes = store.hasFetched["recipe:all"];
  let [loading, setLoading] = useState(!hasFetchedAllRecipes);

  let resources = store.recipes;

  useEffect(() => {
    setInitialRender(false);

    if (!hasFetchedAllRecipes && initialRender) {
      setLoading(true);

      runQuery(QUERY_ALL).then(res => {
        dispatch({ type: "ADD_ALL_RECIPES", payload: res.recipes });
        setLoading(false);
      });
    } else if (initialRender) {
      runQuery(QUERY_ALL).then(res => {
        dispatch({ type: "ADD_ALL_RECIPES", payload: res.recipes });
      });
    }
  }, [dispatch, hasFetchedAllRecipes, initialRender]);

  return [resources, loading];
}

const QUERY_ONE = `
  query($id: Int!) {
    recipes_by_pk(id: $id) {
      id
      recipeUrl
      imageUrl
      name
      instructions
      ingredients
    }
  }
`;

export function useResource(modelName, id) {
  let [initialRender, setInitialRender] = useState(true);
  let { store, dispatch } = useContext(StoreContext);
  let hasFetchedRecipe =
    store.hasFetched[`recipe:${id}`] || store.hasFetched["recipe:all"];
  let [loading, setLoading] = useState(!hasFetchedRecipe);

  let resource =
    store.recipes && store.recipes.find(recipe => recipe.id === +id);

  useEffect(() => {
    setInitialRender(false);

    if (!hasFetchedRecipe && initialRender) {
      setLoading(true);

      runQuery(QUERY_ONE, { variables: { id: +id } }).then(res => {
        dispatch({ type: "ADD_RECIPE", payload: res.recipes_by_pk });
        setLoading(false);
      });
    } else if (initialRender) {
      runQuery(QUERY_ONE, { variables: { id: +id } }).then(res => {
        dispatch({ type: "ADD_RECIPE", payload: res.recipes_by_pk });
      });
    }
  }, [id, dispatch, hasFetchedRecipe, initialRender]);

  return [resource, loading];
}
